import { render, staticRenderFns } from "./form-item-payment-reminders.vue?vue&type=template&id=13511d74&scoped=true"
import script from "./form-item-payment-reminders.vue?vue&type=script&lang=js"
export * from "./form-item-payment-reminders.vue?vue&type=script&lang=js"
import style0 from "./form-item-payment-reminders.vue?vue&type=style&index=0&id=13511d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13511d74",
  null
  
)

export default component.exports